import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const theme = createTheme({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          margin: "0px",
          "&:before": {
            display: "none",
          },
        },
      },
    },
  },
});

export default function Navlinks() {
  const location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{ marginTop: "30px", paddingLeft: "20px", paddingRight: "20px" }}
      >
        <Link
          to={"/appointment"}
          className="linkk"
          id={location.pathname === "/appointment" ? "activeLink" : ""}
        >
          Appointment
        </Link>
        <Accordion
          defaultExpanded
          sx={{
            boxShadow: "none",
            margin: "0px",
          }}
        // elevation={0}
        >
          <AccordionSummary
            sx={{
              fontFamily: "revert-layer",
              fontSize: "19px",
              color: "rgb(99, 115, 129)",
              "& .Mui-expanded": {
                margin: "12px 0 !important",
              },
              "&.Mui-expanded": {
                minHeight: "48px",
              },
            }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Master Menu
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "8px 0px 0px",
            }}
          >
            <Link
              to={"/area"}
              className="link"
              id={location.pathname === "/area" ? "activeLink" : ""}
            >
              Area
            </Link>
            <Link
              to={"/speciality"}
              className="link"
              id={location.pathname === "/speciality" ? "activeLink" : ""}
            >
              Speciality
            </Link>
            <Link
              to={"/doctor"}
              className="link"
              id={location.pathname === "/doctor" ? "activeLink" : ""}
            >
              Doctor
            </Link>
            <Link
              to={"/patient"}
              className="link"
              id={location.pathname === "/patient" ? "activeLink" : ""}
            >
              Patient
            </Link>
            <Link
              to={"/lab"}
              className="link"
              id={location.pathname === "/lab" ? "activeLink" : ""}
            >
              Lab
            </Link>

            <Link
              to={"/doctor-availablity"}
              className="link"
              id={
                location.pathname === "/doctor-availablity" ? "activeLink" : ""
              }
            >
              Availability
            </Link>
            <Link
              to={"/leave-type"}
              className="link"
              id={location.pathname === "/leave-type" ? "activeLink" : ""}
            >
              Leave Type
            </Link>
            <Link
              to={"/doctor-holiday"}
              className="link"
              id={location.pathname === "/doctor-holiday" ? "activeLink" : ""}
            >
              Holidays
            </Link>
            <Link
              to={"/doctor-slot-block"}
              className="link"
              id={location.pathname === "/doctor-slot-block" ? "activeLink" : ""}
            >
              Slot Block
            </Link>
          </AccordionDetails>
        </Accordion>

        <Accordion sx={{ boxShadow: "none" }}>
          <AccordionSummary
            sx={{
              fontFamily: "revert-layer",
              fontSize: "19px",
              color: "rgb(99, 115, 129)",
              "& .Mui-expanded": {
                margin: "12px 0 !important",
              },
              "&.Mui-expanded": {
                minHeight: "48px",
              },
            }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Other
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "8px 0px 0px",
            }}
          >
            <Link
              to={"/faq"}
              className="link"
              id={location.pathname === "/faq" ? "activeLink" : ""}
            >
              FAQ
            </Link>
            <Link
              to={"/help"}
              className="link"
              id={location.pathname === "/help" ? "activeLink" : ""}
            >
              Help
            </Link>
            <Link
              to={"/review"}
              className="link"
              id={location.pathname === "/review" ? "activeLink" : ""}
            >
              Review
            </Link>
            <Link
              to={"/user-master"}
              className="link"
              id={location.pathname === "/user-master" ? "activeLink" : ""}
            >
              User Master
            </Link>
          </AccordionDetails>
        </Accordion>
      </div>
    </ThemeProvider>
  );
}
